// removed by extract-text-webpack-plugin
module.exports = {"box":"style__box___3VawP","title":"style__title___xwSie","title_text":"style__title_text___hFt-N","title_selected":"style__title_selected___3zfhE","title_completed":"style__title_completed___2pDFL","box_selected":"style__box_selected___3DZc-","circle":"style__circle___2KzTE","circle_selected":"style__circle_selected___e4xcL","circle_default":"style__circle_default___1uWos","icon_done":"style__icon_done___1mqY4","flex_element":"style__flex_element___25-3U","img_style":"style__img_style___1pWmB","tooltip":"style__tooltip___2FG4J","tooltiptext":"style__tooltiptext___1dvsg"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/NewSale/StepCard/style.css
// module id = 3226
// module chunks = 0